import {Component, ChangeDetectionStrategy} from '@angular/core';
import {Dialog} from '../../../../../../interfaces/dialog/dialog';
import {DialogParams} from '../../../../../../interfaces/dialog/dialog-params';
import {FormsModule} from '@angular/forms';
import {ConfirmDirective} from '../../../../../../directives/confirm/confirm.directive';
import {DialogService} from '../../../../../../services/dialog/dialog.service';

@Component({
  selector: 'app-parameter-form',
  imports: [
    FormsModule,
    ConfirmDirective
  ],
  templateUrl: './parameter-form.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './parameter-form.component.scss'
})
export class ParameterFormComponent implements Dialog {
  params: any[] = [];

  constructor(
    private dialogService: DialogService,
  ) {
  }

  onDialogInit(params: DialogParams): void {
    this.params = Object.entries(params.data?.parameters);
  }

  add(): void {
    this.params.push(['', '']);
  }

  remove(param: any): void {
    this.params.splice(this.params.indexOf(param), 1);
  }

  submit(): void {
    const params: any = {};

    this.params.forEach((param: any) => {
      if (param[0] !== '') {
        params[param[0]] = param[1];
      }
    });

    this.dialogService.closeDialog(params);
  }
}
